<template>
  <div>
    <v-dialog fullscreen hide-overlay v-model="dialog">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{
            act && act._id ? getName(act.name) : $t('messages.loading')
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="close()" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-tabs color="primary" dark>
          <v-tab
            v-for="item in categoryList"
            :href="'#tab-' + item._id"
            :key="item._id"
            >{{ item.name }}</v-tab
          >
          <v-tabs-items>
            <v-progress-linear
              :active="loading"
              height="3"
              :indeterminate="true"
            ></v-progress-linear>
            <div class="actatotal" v-if="act && act._id && !loading">
              <div v-if="act.faultSystem">
                <v-btn color="amber" small>{{ $t('warnings') }}: 0</v-btn>
                <v-btn color="orange" small>{{ $t('smallFaults') }}: 0</v-btn>
                <v-btn color="orange" small style="min-width: 0">-</v-btn>
                <v-btn color="error" small>{{ $t('seriousFaults') }}: 0</v-btn>
                <v-btn color="error" small style="min-width: 0">-</v-btn>
              </div>
              <div v-else>
                <v-btn color="primary" small>{{ $t('notFaultSystem') }}</v-btn>
              </div>
            </div>
            <v-tab-item
              :value="'tab-' + item._id"
              v-for="item in categoryList"
              :key="item._id"
            >
              <tab-individual :aspects="item.aspects"></tab-individual>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import tabIndividual from './tabIndividual'

export default {
  name: 'ActsView',
  components: { tabIndividual },
  props: {
    modal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      tab: 0
    }
  },
  created() {},
  mounted() {
    this.tab = 0
  },
  methods: {
    ...mapActions({}),
    close() {
      this.dialog = false
      this.tab = 0
    },
    searchResultForTab(idCategory) {
      let categoryAspects = this.aspectForCategory(idCategory)
      let me = this
      let aspectRelated = []
      categoryAspects.forEach(item => {
        let aspect = this.aspectRelatedForCategoryAndType(
          idCategory,
          item.typeAspect
        )
        if (aspect) aspectRelated.push(aspect)
      })
      let filterResultFinal = []
      let filterRepeatContent = []
      aspectRelated.forEach(item => {
        let temp = []
        item.forEach(e => {
          if (filterRepeatContent.indexOf(e.name) === -1) {
            temp.push(e)
            filterRepeatContent.push(e.name)
          }
        })
        if (temp.length > 0) {
          filterResultFinal.push(temp)
        }
      })
      return filterResultFinal
    },
    aspectForCategory(idCategory) {
      if (!this.act || !this.act.aspects) return []
      return this.act.aspects.filter(item => item.categoryAspect == idCategory)
    },
    aspectRelatedForCategoryAndType(idCategory, idType) {
      if (!this.act || !this.act.aspects) {
        return []
      }

      let result = []

      let aspectList = this.act.aspects.filter(
        item => item.categoryAspect === idCategory && item.typeAspect === idType
      )

      let formatView = aspectList.map(aspect => this.createView(aspect))
      formatView = formatView.filter(item => !!item)

      let typeAspect = this.typeList.find(type => type._id == idType)
      let nameTypeAspect = typeAspect ? typeAspect.name : 'TypeAspect'

      aspectList.forEach(aspect =>
        result.push({ name: nameTypeAspect, view: formatView })
      )

      return result
    },
    createView(aspect) {
      if (!aspect) return
      let result = null

      let localAspect = this.aspects.find(item => item._id === aspect.aspectId)
      if (localAspect) {
        result = {
          ...localAspect,
          name: localAspect.name,
          typeScore: localAspect.typeScore
        }
      }
      return result
    }
  },
  computed: {
    ...mapState({
      act: state => state.acts.actSelected,
      loading: state => state.acts.loading,
      aspects: state => state.aspects.list
    }),
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.$emit('close', value)
        }
      }
    },
    categoryList() {
      if (!this.act || !this.act.categoryAspects) {
        return []
      }

      let categoryList = this.act.categoryAspects.map(category => {
        return {
          _id: category._id,
          name: this.getName(category.name),
          order: category.order,
          aspects: this.searchResultForTab(category._id)
        }
      })
      return categoryList.sort((a, b) => a.order - b.order)
    },
    typeList() {
      if (!this.act || !this.act.typeAspects) {
        return []
      }

      let typeList = this.act.typeAspects.map(type => {
        return {
          _id: type._id,
          name: this.getName(type.name),
          order: type.order
        }
      })
      return typeList.sort((a, b) => a.order - b.order)
    }
  }
}
</script>
<style>
.actatotal {
  text-align: center;
}
</style>
